import { NavigateFunction } from "react-router-dom";
import { PaginationKeys } from "../../../enums/nycbsPharmaOrder";
import {
  persistCmmOrderAssigneeId,
  resolveAssigneeIdFromCmmTableRow,
} from "../../../utils/cmmOrderAssigneeIdStorage";

export const handleEndIndexOfTable = (
  endIndex: number,
  ordersData: any[] | null,
  pageData: any,
  finalLimitToUse: number,
  setEndIndex: (index: number) => void,
  setBatchNumberRetreived: (callback: (prev: number[]) => number[]) => void,
  setTableDataForContext: (name: string, data: any) => void,
) => {
  setEndIndex(endIndex);
  if (
    ordersData &&
    pageData?.[PaginationKeys.TotalCount] !== null &&
    endIndex < (pageData?.[PaginationKeys.TotalCount] ?? 0) - 1 &&
    endIndex === ordersData.length - 1
  ) {
    const nextBatchFetch = Math.round(ordersData.length / finalLimitToUse);
    if (nextBatchFetch > 0) {
      setBatchNumberRetreived((prevBatchNumberRetrieved) => {
        if (!prevBatchNumberRetrieved.includes(nextBatchFetch)) {
          setTableDataForContext("allCmmOrders", {
            lastBatchFetched: nextBatchFetch,
          });
          return [...prevBatchNumberRetrieved, nextBatchFetch];
        }
        return prevBatchNumberRetrieved;
      });
    }
  }
};

export const handleRowExpandChangeFromTableBody = (
  expanded: boolean,
  id: string,
  tableDataForTable: any[],
  setTableDataForTable: (data: any[]) => void,
) => {
  const newTableData = tableDataForTable.map((row) =>
    row.id === id
      ? {
          ...row,
          expandableRowIcon: {
            ...row.expandableRowIcon,
            isExpanded: expanded,
          },
        }
      : {
          ...row,
          expandableRowIcon: {
            ...row.expandableRowIcon,
            isExpanded: false, // Close all other rows
          },
        },
  );
  setTableDataForTable(newTableData);
};

/**
 * Navigates to the insurance-details form for a CMM order row.
 * Carries `assignee_id` via location state and sessionStorage because the
 * single-order API often returns it empty.
 *
 * @param rowData - Formatted CMM order table row (must include `id`)
 * @param navigate - React Router navigate function
 */
export const navigateToForm = (rowData: any, navigate: NavigateFunction) => {
  const docId = rowData["id"];
  const assigneeId = resolveAssigneeIdFromCmmTableRow(rowData);
  persistCmmOrderAssigneeId(docId, assigneeId);
  navigate(`/pharma-pa-worklists/insurance-details/${docId}`, {
    state: {
      assignee_id: assigneeId,
    },
  });
};
